import { colors } from '~tokens/internal'
import { type AIInteractionTypeEnum } from '~types'

// ---------------------------------------------------------------------------
// Canonical per-surface color map
//
// Single source of truth for AI surface brand colors across the product.
// - SCSS components: use the BEM modifiers in _tokens.scss
// - JS consumers (charts, inline styles): import getAISurfaceColors() from here
// ---------------------------------------------------------------------------

// AI surfaces are the API's interaction types plus 'ALL' for aggregate views.
export type AISurface = AIInteractionTypeEnum | 'ALL'

export interface AISurfaceColors {
  bg: string
  fg: string
}

const AI_SURFACE_COLORS: Record<AISurface, AISurfaceColors> = {
  ALL: { bg: colors.indigo[50], fg: colors.indigo[500] },
  ASSISTANT: { bg: colors.indigo[50], fg: colors.indigo[500] },
  CHAT: { bg: colors.blue[50], fg: colors.blue[500] },
  EMAIL: { bg: colors.orange[50], fg: colors.orange[500] },
  SEARCH: { bg: colors.teal[50], fg: colors.teal[500] },
  SMS: { bg: colors.pink[50], fg: colors.pink[500] },
  VOICE: { bg: colors.purple[50], fg: colors.purple[500] },
  WHATSAPP: { bg: colors.pink[50], fg: colors.pink[500] },
}

const FALLBACK_COLORS: AISurfaceColors = {
  bg: colors.neutral[50],
  fg: colors.neutral[500],
}

export function getAISurfaceColors(surface: AISurface): AISurfaceColors {
  return AI_SURFACE_COLORS[surface] ?? FALLBACK_COLORS
}

export function getAISurfaceFg(surface: AISurface): string {
  return getAISurfaceColors(surface).fg
}

export function getAISurfaceBg(surface: AISurface): string {
  return getAISurfaceColors(surface).bg
}
